module.exports = __webpack_public_path__ + "static/media/thumb.cb4de86a.jpg";